<div class="container-fluid main">
  @if (registryUpdated) {
    <div class="alert alert-success mt-3">
      {{ "DEVICE_REGISTRY_UPDATED_WITH_ID" | translate }} '{{ deviceIdAdded }}'
    </div>
  }

  @if (registryUpdatedMany) {
    <div class="alert alert-success mt-3">
      {{ devsAddedToReg }} {{ "DEVICES_REGISTRY_UPDATED" | translate }}
    </div>
  }

  @if (registryUpdatedError) {
    <div class="alert alert-danger mt-3">
      {{ "DEVREGISTRY_UPDATE_ERROR" | translate }}
    </div>
  }

  @if (registryUpdatedManyError) {
    <div class="alert alert-danger mt-3">
      {{ "DEVREGISTRY_UPDATE_ERROR" | translate }}
    </div>
  }

  @if (loadDevicesError) {
    <div class="alert alert-danger mt-3">
      {{ "ERROR" | translate }}
    </div>
  }

  @if (showAddProductDialog) {
    <device-add-inventory
      [customerSelectionData]="customerSelectionData"
      [locationList]="locationList"
      (closeAddFormEvent)="closeAddBaseForm()"
      (deviceAddedEvent)="deviceAdded($event)"
      (deviceAddedError)="deviceAddedError($event)">
    </device-add-inventory>
  }

  <div class="d-flex mb-4 justify-content-between">
    <div class="d-flex position-relative">
      <button class="btn btn-primary mr-2" (click)="openAddProductDialog()">
        <i class="fa-solid fa-plus"></i>
        {{ "ADD_PRODUCT" | translate }}
      </button>
      <button (click)="downloadCsv()" class="btn btn-light mr-2">
        <i id="downloadCSV" class="fa-light fa-download"></i>
        {{"DOWNLOAD_CSV" | translate}}
      </button>
      <button (click)="filterDialog()" id="filter" #toggleFilterDialog class="mr-2 btn btn-light">
        <i class="fa-regular fa-filter mr-1"></i>
        {{ "FILTER" | translate }}
        @if (!showFilterDialog) {
          <i class="fas fa-chevron-down" id="menuicon"></i>
        }
        @if (showFilterDialog) {
          <i class="fas fa-chevron-up" #toggleFilterDialog></i>
        }
      </button>
      @if (hasActiveFilters) {
        <button class="mr-2 btn btn-light" (click)="clearFilters()">
          <i class="fa-regular fa-filter-slash mr-1"></i>
          {{ "CLEAR_FILTERS" | translate }}
        </button>
      }
      @if (showFilterDialog) {
        <div class="filter-dialog" #filterMenu>
          <div class="filter-search-row">
            <i class="fa-regular fa-magnifying-glass filter-search-icon"></i>
            <input
              class="filter-search-input"
              type="text"
              [(ngModel)]="filterPanelSearch"
              placeholder=" {{ 'SEARCH' | translate }}..." />
          </div>
          <div class="d-flex align-items-start">
            <div class="filter-column">
              <p class="filter-head"><b>{{ "DEVICE_TYPE" | translate }}</b></p>
              <section class="filter-section">
                @for (devType of filteredDeviceTypeFilters; track devType) {
                  <p>
                    <mat-checkbox (change)="isDeviceFilterChecked(devType, $event)"
                      [checked]="selectedFilters.deviceTypes.includes(devType)">
                      {{ getDeviceType(devType) }}
                    </mat-checkbox>
                  </p>
                }
              </section>
            </div>
            <div class="filter-column">
              <p class="filter-head"><b>{{ "LOCATION" | translate }}</b></p>
              <section class="filter-section">
                @for (location of filteredLocationFilters; track location) {
                  <p [title]="getLocationName(location)">
                    <mat-checkbox
                      (change)="isLocationFilterChecked(location, $event)"
                      [checked]="selectedFilters.locations.includes(location)">
                      {{ getLocationName(location) }}
                    </mat-checkbox>
                  </p>
                }
              </section>
            </div>
            <div class="filter-column">
              <p class="filter-head"><b>{{ "STATUS" | translate }}</b></p>
              <section class="filter-section">
                <p>
                  <mat-checkbox [(ngModel)]="selectedFilters.statusOnline" (change)="filterDevices()">
                    {{ "Online" | translate }}
                  </mat-checkbox>
                </p>
                <p>
                  <mat-checkbox [(ngModel)]="selectedFilters.statusOfflineUnder24h" (change)="filterDevices()">
                    {{ "OfflineUnder24h" | translate }}
                  </mat-checkbox>
                </p>
                <p>
                  <mat-checkbox [(ngModel)]="selectedFilters.statusOfflineOver24h" (change)="filterDevices()">
                    {{ "OfflineOver24h" | translate }}
                  </mat-checkbox>
                </p>
                <p>
                  <mat-checkbox [(ngModel)]="selectedFilters.statusLowBattery" (change)="filterDevices()">
                    {{ "BATTERY_STATUS_WARNING" | translate }}
                  </mat-checkbox>
                </p>
                <p>
                  <mat-checkbox [(ngModel)]="selectedFilters.statusInCustomerStock" (change)="filterDevices()">
                    {{ "CUSTOMER_STOCK" | translate }}
                  </mat-checkbox>
                </p>
                <p>
                  <mat-checkbox [(ngModel)]="selectedFilters.statusInEveronStock" (change)="filterDevices()">
                    {{ "EVERON_STOCK" | translate }}
                  </mat-checkbox>
                </p>
                <p>
                  <mat-checkbox [(ngModel)]="selectedFilters.statusInService" (change)="filterDevices()">
                    {{ "SERVICE_OR_REPAIR" | translate }}
                  </mat-checkbox>
                </p>
                <p>
                  <mat-checkbox [(ngModel)]="selectedFilters.statusLost" (change)="filterDevices()">
                    {{ "LOST" | translate }}
                  </mat-checkbox>
                </p>
              </section>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="d-flex">
      <input
        #deviceSearchInput
        class="border rounded rightCornersSquare shadow-sm"
        type="text"
        (keydown.enter)="search()"
        placeholder="{{ 'SEARCH' | translate }}..." />
      <button (click)="search()" class="btn btn-primary leftCornersSquare shadow-sm">
        <i class="fa-sharp fa-solid fa-magnifying-glass"></i>
      </button>
    </div>
  </div>

      @if (!pageInited) {
        <p>{{ "LOADING" | translate }}...</p>
      }

      @if (pageCount > 0) {
        <!--
        <div class="p-0 mb-2">
          <mat-accordion multi="true">
            <mat-expansion-panel class="summary mat-typography">
              <mat-expansion-panel-header class="summary-head">
                <mat-panel-title>
                  <h4 class="summary-head-content">
                    {{ "SUMMARY" | translate }}
                  </h4>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="summary-content" *ngIf="devTypeSummary; else loading">
                <div class="summary-row" *ngIf="devTypeSummary.length > 0">
                  <div class="colbox">
                    <p>&nbsp;</p>
                    <p>{{ "TOTAL_AMOUNT" | translate }}:</p>
                    <p>{{ "IN_USE" | translate }}:</p>
                    <p>{{ "EVERON_INVENTORY" | translate }}:</p>
                    <p>{{ "SERVICE_OR_REPAIR" | translate }}:</p>
                  </div>
                  <div class="colbox" *ngFor="let type of devTypeSummary">
                    <p><b>&nbsp;{{ getDeviceType(type.deviceType)}}&nbsp;</b></p>
                    <p>{{ type.totalAmount }}</p>
                    <p>{{ type.inUseAmount }}</p>
                    <p>{{ type.inStockAmount }}</p>
                    <p>{{ type.inServiceAmount }}</p>
                  </div>
                </div>
                <p *ngIf="devTypeSummary.length === 0">
                  {{ "NO_RESULT" | translate }}
                </p>
              </div>
              <ng-template #loading>
                <div class="summary-content">
                  <p>{{ "LOADING" | translate }}...</p>
                </div>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        -->
        <table id="deviceTable">
          <thead>
            <tr class="pl-5">
              @for (header of headerInfo; track header) {
                <th class="header" [class]="header.class" [ngClass]="{ hpointer: !header.sortDisabled }"
                  (click)="sort(header.sorter)">
                  <div class="d-inline-flex">
                    <div>{{ header.headName | translate }}</div>
                    <div class="ml-2" style="margin-top: 1px;">
                      @if (header.sorter !== selectedFilters.sortKey || selectedFilters.sortBy == 0) {
                        <i
                          class="fa-solid fa-sort"
                          style="color: #a9a9a9">
                        </i>
                      }
                      @if (header.sorter === selectedFilters.sortKey && selectedFilters.sortBy === -1) {
                        <i
                          class="fa-solid fa-sort-up">
                        </i>
                      }
                      @if (header.sorter === selectedFilters.sortKey && selectedFilters.sortBy === 1) {
                        <i
                          class="fa-solid fa-sort-down">
                        </i>
                      }
                    </div>
                  </div>
                </th>
              }
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (device of dataSource; track device) {
              @if (pageLoaded) {
                <tr>
                  <td>
                    @if (device.devTypeName || device.devType) {
                      <span innerHTML="{{device.devTypeName | highlight : deviceFilter}} ({{ (device.devType | deviceTypeCode | highlight : deviceFilter) || '-' }})"></span>
                    } @else {
                      <span class="text-muted fst-italic">{{ "UNKNOWN" | translate }}</span>
                    }
                  </td>
                  <td innerHTML="{{ (device.deviceName | highlight : deviceFilter) || '-' }}"></td>
                  <td innerHTML="{{ (device.devId | highlight : deviceFilter) || '-' }}"></td>
                  @if (isDeviceBasestation(device)) {
                    <td>
                      <div class="selectWrapper">
                        <select name="location"
                          id="location"
                          #deviceLocation
                          (change)="onSelected(deviceLocation, device, $event)"
                          (click)="$event.stopPropagation()"
                          class="form-select form-select-sm">
                          <option [value]="null" [disabled]="true" default>
                            {{ "EVERON_INVENTORY" | translate }}
                          </option>
                          @if (device.statusInEveronStock) {
                            <option [value]="null">
                              {{ "CUSTOMER_INVENTORY" | translate }}
                            </option>
                          }
                          @if (!device.statusInEveronStock) {
                            <option [value]="null" selected>
                              {{ "CUSTOMER_INVENTORY" | translate }}
                            </option>
                          }
                          @if (device.locationId) {
                            <option [value]="device.locationId" selected>
                              {{ device.location }}
                            </option>
                          }
                          @if (device.locationId) {
                            @for (location of removeDuplicateLocation(companyGroupLocations, device.location); track location) {
                              <option
                                [disabled]="device.companyId !== location.companyID"
                                [value]="location.locationID">
                                {{ location.locationName }}
                              </option>
                            }
                          }
                          @if (!device.locationId) {
                            @for (location of removeDuplicateLocation(companyGroupLocations, device.location); track location) {
                              <option
                                [value]="location.locationID">
                                {{ location.locationName }}
                              </option>
                            }
                          }
                        </select>
                      </div>
                    </td>
                  }
                  @if (!isDeviceBasestation(device)) {
                    @if (device.location) {
                      <td
                      innerHTML="{{ (device.location | highlight : deviceFilter) }}"></td>
                    }
                    @if (!device.location) {
                      <td>
                        @if (device.statusInEveronStock) {
                          <select name="location"
                            id="location"
                            #deviceLocation
                            (change)="onSelected(deviceLocation, device, $event)"
                            (click)="$event.stopPropagation()"
                            class="form-select form-select-sm">
                            <option [value]="null" [disabled]="true" default>
                              {{ "EVERON_INVENTORY" | translate }}
                            </option>
                            @if (device.statusInEveronStock) {
                              <option [value]="null">
                                {{ "CUSTOMER_INVENTORY" | translate }}
                              </option>
                            }
                          </select>
                        }
                        @if (!device.statusInEveronStock) {
                          <span>{{ "CUSTOMER_INVENTORY" | translate
                          }}</span>
                        }
                      </td>
                    }
                  }
                  <td innerHTML="{{ (device.locationAddress | highlight : deviceFilter) || '-' }}"></td>
                  <td innerHTML="{{ (device.resident | highlight : deviceFilter) || '-' }}"></td>
                  <td innerHTML="{{ (device.sSnumber | highlight : deviceFilter) || '-' }}"></td>
                  @if (bindingTimeConfig.visible) {
                    <td
                      innerHTML="{{ (device.bindingTimeEnd | bindingTime : device.statusInEveronStock : bindingTimeConfig | highlight : deviceFilter) }} {{'DAYS' |translate}}">
                    </td>
                  }
                  <td>
                    <div class="deviceStatusBadgeWrapper">
                      <app-feature-badge [feature]="device | resolveDeviceStatus"></app-feature-badge>
                    </div>
                  </td>
                  <td>
                    <i (click)="openDialog(device)"
                    class="fa-regular fa-ellipsis fa-xl p-2 pr-3 cursorPointer"></i>
                  </td>
                </tr>
              }
            }
            @if (pageLoaded && dataSource !== null && !dataSource.length && !loadDevicesError) {
              <p>{{ "NO_DEVICES_WITH_FILTER" | translate }}</p>
            }
            @if (!pageLoaded) {
              <mat-spinner class="my-spinner m-2"></mat-spinner>
            }
            @if (!pageLoaded) {
              <p class="m-2">{{ "LOADING" | translate }}...</p>
            }
          </tbody>
        </table>
        <div class="d-flex align-items-baseline paginatorBox my-4">
          <div class="m-2">
            {{ "ITEMS" | translate }}: {{numberOfDevices}}
          </div>
          <mat-paginator class="ml-2 mb-1"
            [showFirstLastButtons]="true"
            [length]="numberOfDevices"
            [pageSize]="pageSize"
            [pageSizeOptions]="[25, 50, 75, 100]"
            [pageIndex]="currentPageIndex"
            (page)="handlePageEvent($event)"
            aria-label="Select page">
          </mat-paginator>
        </div>
      }

    </div>
